export default __webpack_public_path__ + "static/media/companyon.1809d3bd.svg";